import moment from 'moment-timezone';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from '@globals';
import { jwtOptions } from './app.module';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent {
  clockS: Subscription;
  constructor() {
    moment.tz.setDefault('UTC');
    moment.defaultFormat = 'YYYY-MM-DD HH:mm:ss';

    const webHost = window.location.hostname;
    const apiHost = webHost.match(/^w{3}/) ? webHost.replace(/^w{3}/, 'api') : `api.${webHost}`;
    const socketHost = webHost.match(/^w{3}/) ? webHost.replace(/^w{3}/, 'io') : `io.${webHost}`;
    Globals.apiHost = `${apiHost}`;
    Globals.socketHost = `${socketHost}`;
    console.log('apiHost', Globals.apiHost);
    console.log('socketHost', Globals.socketHost);

    jwtOptions.addAllowedDomains(Globals.apiHost);
  }
}
